import { render } from "./Assessment.vue?vue&type=template&id=2b7bedd8"
import script from "./Assessment.js?vue&type=script&lang=js"
export * from "./Assessment.js?vue&type=script&lang=js"

import "./Assessment.vue?vue&type=style&index=0&id=2b7bedd8&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__